import Vue from 'vue';
export const localizationService = {
    setLang,
};

function setLang(lng) {

    var url = "/Localisation/SetLang";

    const headersParam = {
        "Accept": "*/*",
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        "Pragma": "no-cache",
    }

    return Vue.prototype.$axios.get(url, { params: { lang: lng }, headers: headersParam });

}